export default __webpack_public_path__ + "static/media/solar.04eb05e6.jpg";